import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import WatsApp from "../pages/SignIn/Watsapp";
import Dashboard from "../pages/Home";
import NewDashboard from "../pages/Dashboard/main/NewDashboard";
import { Riple } from "react-loading-indicators";

import PrivacyPolicy from "../pages/Hompage/PrivacyPolicy";
import RefundAndCancle from "../pages/Hompage/RefundAndCancle";
import PlanHomePage from "../pages/Hompage/Planpage";
import Aboutus from "../pages/Hompage/Aboutus";
import Contactus from "../pages/Hompage/Contactus";
import Signin2 from "../pages/SignIn/Signin2";
import TermsCondition from "../pages/Hompage/TermsCondition";
import Profile from "../pages/Dashboard/main/Profile";
import UserDetailPage from "../pages/SignIn/UserDetailPage";
import BlogPage from "../pages/Hompage/blog/Blogs";
import BlogDetails from "../pages/Hompage/blog/BlogDetails";
import FairPlayPolicy from "../pages/Hompage/FairPlayPolicy";
import RiskDisclosurePolicy from "../pages/Hompage/RiskDisclosurePolicy";

const Mainroute = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); // Adjust timeout as needed

    return () => clearTimeout(timer);
  }, [location]);
  return (
    <>
      {/* {loading && (
          <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
            <Riple color="#FF782D" size="medium" text="" textColor="" />
          </div>
        )} */}
      <Routes>
        <Route path="/" element={<Dashboard />} />
        {/* <Route path='/login' element={<Signin/>}/> */}

        <Route path="/login" element={<Signin2 />} />
        <Route path="/login-info" element={<WatsApp />} />
        <Route path="/courses" element={<PlanHomePage />} />
        <Route path="/terms-condition" element={<TermsCondition />} />
        <Route path="/fairPlayPolicy" element={<FairPlayPolicy />} />
        <Route path="/riskDiscloserPolicy" element={<RiskDisclosurePolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundAndCancle />} />
        <Route path="/dash/*" element={<NewDashboard />} />
        <Route path="/about-us" element={<Aboutus />} />
        <Route path="/contact-us" element={<Contactus />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/UserDetailPage" element={<UserDetailPage />} />
        {/* blog route */}
        <Route path="/blogs" element={<BlogPage />} />

        <Route path="/blog/:slug" element={<BlogDetails />} />
        {/* <Route path="/login" element={<Navigate to="/" replace />} /> */}
      </Routes>
    </>
  );
};

export default Mainroute;
